import { render, staticRenderFns } from "./Papeles.vue?vue&type=template&id=48ac172d&"
import script from "./Papeles.vue?vue&type=script&lang=js&"
export * from "./Papeles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports